import { render, staticRenderFns } from "./EmployeeTable.vue?vue&type=template&id=27fb60df&scoped=true&"
import script from "./EmployeeTable.vue?vue&type=script&lang=js&"
export * from "./EmployeeTable.vue?vue&type=script&lang=js&"
import style0 from "./EmployeeTable.vue?vue&type=style&index=0&id=27fb60df&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27fb60df",
  null
  
)

export default component.exports